import { Resolution } from "@common/helpers/Resolution.class";
import { outerHeight, width } from "@common/helpers/domManipulation";
import { breakSettings } from "@client/components/Slider/slider";
import { debounce } from "@client/common/js/helpers/debounce";

function init($view) {
	const LAZY_LOAD_CLASS = "lazyload";

	const $page = $view[0];
	const resolution = new Resolution();
	const $cardSlider = $page.querySelectorAll("ul.cardSlider");

	if (!$cardSlider) {
		return;
	}

	initCardSlider();

	window.addEventListener("resize", () => debounce(redrawSlider, 150));

	function initCardSlider() {
		$cardSlider.forEach(($slider) => {
			$slider.querySelectorAll("picture source").forEach(($source) => {
				if ($source.dataset.srcset) {
					$source.srcset = $source.dataset.srcset;
				}
			});
		});

		window.addEventListener("load", () => {
			$cardSlider.forEach(($slider) => {
				const bxSlider = $($slider).bxSlider(buildSliderConfig($slider));
				$slider.querySelectorAll("img").forEach(($img) => {
					if ($img.classList.contains(LAZY_LOAD_CLASS)) {
						$img.classList.remove(LAZY_LOAD_CLASS);
						$img.src = $img.dataset.src;
					}
				});

				/* Add slider to the element */
				$slider.bxSlider = bxSlider;
			});
		});
	}

	function buildSliderConfig($slider) {
		var isDesktop = resolution.isLargerThan(resolution.smallMobileResolutionSplit);
		const maxSlides = getMaxSlides();
		const upTime = $slider.dataset.pause;

		if ($slider.querySelectorAll("li section").length <= maxSlides) {
			isDesktop = false;
		}

		return {
			auto: isDesktop,
			minSlides: 1,
			maxSlides: maxSlides,
			breaks: breakSettings.smallCardBreakSettings,
			slideWidth: 270,
			infiniteLoop: isDesktop,
			pager: false,
			autoReload: false,
			slideMargin: 20,
			pause: upTime ? upTime * 1000 : 5000,
			autoHover: true,
			useCSS: false,
			startSlide: 0,
			moveSlides: 1,
			onSliderRedraw: () => {
				const $sections = $page.querySelectorAll("li section");

				if ($sections) {
					$sections.forEach(($section) => {
						$section.height = "auto";
					});

					const height = Array.prototype.reduce.call(
						Array.from($sections).map(($e) => outerHeight($e)),
						(current, previous) => Math.max(current, previous),
					);

					$sections.forEach(($section) => {
						$section.height = height;
					});
				}
			},
		};
	}

	function getMaxSlides() {
		const breaks = [
			{ screen: 0, slides: 1, pager: false },
			{ screen: 570, slides: 2 },
			{ screen: 768, slides: 3 },
			{ screen: 1050, slides: 4 },
		];
		const validSlides = breaks.filter(function (b) {
			return width(window.document.documentElement) >= b.screen;
		});

		const maxSlides = validSlides.length > 0 ? validSlides[validSlides.length - 1].slides : 1;

		return maxSlides;
	}

	function redrawSlider() {
		$cardSlider.forEach(($slider) => {
			/* Destroy current slider */
			$slider.bxSlider.destroySlider();

			/* Generate new slider with new config */
			const config = buildSliderConfig($slider);
			const bxSlider = $($slider).bxSlider(config);

			/* Update slider */
			$slider.bxSlider = bxSlider;
		});
	}
}

export default {
	view: "brandHomePage",
	init,
};
